import styled from 'styled-components';

export const DiningOptionWrapper = styled.div`
  margin-bottom: 20px;
`;

export const DiningOptionNameContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: 10px;
`;

export const AdditionalInfoWrapper = styled.div`
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`;
